// 常用机场字典（IATA 代码 → 中英文名称）
// 涵盖中国主要城市 + 万国旅行社业务相关的目的地（澳新美欧亚主要枢纽）
const AIRPORTS = [
  // 中国大陆
  { code: 'PEK', cn: '北京首都国际机场', en: 'Beijing Capital International Airport' },
  { code: 'PKX', cn: '北京大兴国际机场', en: 'Beijing Daxing International Airport' },
  { code: 'PVG', cn: '上海浦东国际机场', en: 'Shanghai Pudong International Airport' },
  { code: 'SHA', cn: '上海虹桥国际机场', en: 'Shanghai Hongqiao International Airport' },
  { code: 'CAN', cn: '广州白云国际机场', en: 'Guangzhou Baiyun International Airport' },
  { code: 'SZX', cn: '深圳宝安国际机场', en: 'Shenzhen Baoan International Airport' },
  { code: 'CTU', cn: '成都双流国际机场', en: 'Chengdu Shuangliu International Airport' },
  { code: 'TFU', cn: '成都天府国际机场', en: 'Chengdu Tianfu International Airport' },
  { code: 'CKG', cn: '重庆江北国际机场', en: 'Chongqing Jiangbei International Airport' },
  { code: 'XIY', cn: '西安咸阳国际机场', en: 'Xian Xianyang International Airport' },
  { code: 'KMG', cn: '昆明长水国际机场', en: 'Kunming Changshui International Airport' },
  { code: 'HGH', cn: '杭州萧山国际机场', en: 'Hangzhou Xiaoshan International Airport' },
  { code: 'NKG', cn: '南京禄口国际机场', en: 'Nanjing Lukou International Airport' },
  { code: 'WUH', cn: '武汉天河国际机场', en: 'Wuhan Tianhe International Airport' },
  { code: 'CSX', cn: '长沙黄花国际机场', en: 'Changsha Huanghua International Airport' },
  { code: 'XMN', cn: '厦门高崎国际机场', en: 'Xiamen Gaoqi International Airport' },
  { code: 'TAO', cn: '青岛胶东国际机场', en: 'Qingdao Jiaodong International Airport' },
  { code: 'TSN', cn: '天津滨海国际机场', en: 'Tianjin Binhai International Airport' },
  { code: 'DLC', cn: '大连周水子国际机场', en: 'Dalian Zhoushuizi International Airport' },
  { code: 'SHE', cn: '沈阳桃仙国际机场', en: 'Shenyang Taoxian International Airport' },
  { code: 'HRB', cn: '哈尔滨太平国际机场', en: 'Harbin Taiping International Airport' },
  { code: 'URC', cn: '乌鲁木齐地窝堡国际机场', en: 'Urumqi Diwopu International Airport' },
  { code: 'LHW', cn: '兰州中川国际机场', en: 'Lanzhou Zhongchuan International Airport' },
  { code: 'KWE', cn: '贵阳龙洞堡国际机场', en: 'Guiyang Longdongbao International Airport' },
  { code: 'NNG', cn: '南宁吴圩国际机场', en: 'Nanning Wuxu International Airport' },
  { code: 'HAK', cn: '海口美兰国际机场', en: 'Haikou Meilan International Airport' },
  { code: 'SYX', cn: '三亚凤凰国际机场', en: 'Sanya Phoenix International Airport' },
  { code: 'LXA', cn: '拉萨贡嘎国际机场', en: 'Lhasa Gonggar International Airport' },

  // 港澳台
  { code: 'HKG', cn: '香港国际机场', en: 'Hong Kong International Airport' },
  { code: 'MFM', cn: '澳门国际机场', en: 'Macau International Airport' },
  { code: 'TPE', cn: '台北桃园国际机场', en: 'Taipei Taoyuan International Airport' },
  { code: 'TSA', cn: '台北松山机场', en: 'Taipei Songshan Airport' },
  { code: 'KHH', cn: '高雄国际机场', en: 'Kaohsiung International Airport' },

  // 新西兰
  { code: 'AKL', cn: '奥克兰国际机场', en: 'Auckland International Airport' },

  // 日韩
  { code: 'NRT', cn: '东京成田国际机场', en: 'Tokyo Narita International Airport' },
  { code: 'HND', cn: '东京羽田机场', en: 'Tokyo Haneda Airport' },
  { code: 'KIX', cn: '大阪关西国际机场', en: 'Osaka Kansai International Airport' },
  { code: 'NGO', cn: '名古屋中部国际机场', en: 'Nagoya Chubu Centrair International Airport' },
  { code: 'FUK', cn: '福冈机场', en: 'Fukuoka Airport' },
  { code: 'CTS', cn: '札幌新千岁机场', en: 'Sapporo New Chitose Airport' },
  { code: 'OKA', cn: '那霸机场', en: 'Naha Airport' },
  { code: 'ICN', cn: '首尔仁川国际机场', en: 'Seoul Incheon International Airport' },
  { code: 'GMP', cn: '首尔金浦国际机场', en: 'Seoul Gimpo International Airport' },
  { code: 'PUS', cn: '釜山金海国际机场', en: 'Busan Gimhae International Airport' },
  { code: 'CJU', cn: '济州国际机场', en: 'Jeju International Airport' },

  // 东南亚
  { code: 'SIN', cn: '新加坡樟宜国际机场', en: 'Singapore Changi Airport' },
  { code: 'KUL', cn: '吉隆坡国际机场', en: 'Kuala Lumpur International Airport' },
  { code: 'BKK', cn: '曼谷素万那普国际机场', en: 'Bangkok Suvarnabhumi Airport' },
  { code: 'DMK', cn: '曼谷廊曼国际机场', en: 'Bangkok Don Mueang International Airport' },
  { code: 'HKT', cn: '普吉国际机场', en: 'Phuket International Airport' },
  { code: 'CNX', cn: '清迈国际机场', en: 'Chiang Mai International Airport' },
  { code: 'CGK', cn: '雅加达苏加诺·哈达国际机场', en: 'Jakarta Soekarno-Hatta International Airport' },
  { code: 'DPS', cn: '巴厘岛伍拉莱国际机场', en: 'Bali Ngurah Rai International Airport' },
  { code: 'MNL', cn: '马尼拉尼诺·阿基诺国际机场', en: 'Manila Ninoy Aquino International Airport' },
  { code: 'CEB', cn: '宿务麦克坦机场', en: 'Cebu Mactan International Airport' },
  { code: 'SGN', cn: '胡志明市新山一国际机场', en: 'Ho Chi Minh City Tan Son Nhat International Airport' },
  { code: 'HAN', cn: '河内内排国际机场', en: 'Hanoi Noi Bai International Airport' },
  { code: 'PNH', cn: '金边国际机场', en: 'Phnom Penh International Airport' },
  { code: 'REP', cn: '暹粒国际机场', en: 'Siem Reap International Airport' },

  // 美洲
  { code: 'LAX', cn: '洛杉矶国际机场', en: 'Los Angeles International Airport' },
  { code: 'SFO', cn: '旧金山国际机场', en: 'San Francisco International Airport' },
  { code: 'JFK', cn: '纽约肯尼迪国际机场', en: 'New York John F. Kennedy International Airport' },
  { code: 'EWR', cn: '纽瓦克自由国际机场', en: 'Newark Liberty International Airport' },
  { code: 'ORD', cn: '芝加哥奥黑尔国际机场', en: 'Chicago OHare International Airport' },
  { code: 'IAD', cn: '华盛顿杜勒斯国际机场', en: 'Washington Dulles International Airport' },
  { code: 'SEA', cn: '西雅图-塔科马国际机场', en: 'Seattle-Tacoma International Airport' },
  { code: 'BOS', cn: '波士顿洛根国际机场', en: 'Boston Logan International Airport' },
  { code: 'MIA', cn: '迈阿密国际机场', en: 'Miami International Airport' },
  { code: 'LAS', cn: '拉斯维加斯哈里·里德国际机场', en: 'Las Vegas Harry Reid International Airport' },
  { code: 'YVR', cn: '温哥华国际机场', en: 'Vancouver International Airport' },
  { code: 'YYZ', cn: '多伦多皮尔逊国际机场', en: 'Toronto Pearson International Airport' },
  { code: 'YUL', cn: '蒙特利尔特鲁多国际机场', en: 'Montreal Trudeau International Airport' },

  // 欧洲
  { code: 'LHR', cn: '伦敦希思罗机场', en: 'London Heathrow Airport' },
  { code: 'LGW', cn: '伦敦盖特威克机场', en: 'London Gatwick Airport' },
  { code: 'CDG', cn: '巴黎戴高乐机场', en: 'Paris Charles de Gaulle Airport' },
  { code: 'ORY', cn: '巴黎奥利机场', en: 'Paris Orly Airport' },
  { code: 'FRA', cn: '法兰克福机场', en: 'Frankfurt Airport' },
  { code: 'MUC', cn: '慕尼黑机场', en: 'Munich Airport' },
  { code: 'AMS', cn: '阿姆斯特丹史基浦机场', en: 'Amsterdam Schiphol Airport' },
  { code: 'ZRH', cn: '苏黎世机场', en: 'Zurich Airport' },
  { code: 'FCO', cn: '罗马菲乌米奇诺机场', en: 'Rome Fiumicino Airport' },
  { code: 'MXP', cn: '米兰马尔彭萨机场', en: 'Milan Malpensa Airport' },
  { code: 'MAD', cn: '马德里巴拉哈斯机场', en: 'Madrid Barajas Airport' },
  { code: 'BCN', cn: '巴塞罗那埃尔普拉特机场', en: 'Barcelona El Prat Airport' },
  { code: 'IST', cn: '伊斯坦布尔机场', en: 'Istanbul Airport' },
  { code: 'SVO', cn: '莫斯科谢列梅捷沃国际机场', en: 'Moscow Sheremetyevo International Airport' },
  { code: 'VIE', cn: '维也纳国际机场', en: 'Vienna International Airport' },
  { code: 'CPH', cn: '哥本哈根机场', en: 'Copenhagen Airport' },
  { code: 'OSL', cn: '奥斯陆加勒穆恩机场', en: 'Oslo Gardermoen Airport' },
  { code: 'ARN', cn: '斯德哥尔摩阿兰达机场', en: 'Stockholm Arlanda Airport' },
  { code: 'HEL', cn: '赫尔辛基万塔国际机场', en: 'Helsinki Vantaa International Airport' },
];

const CODE_MAP = {};
AIRPORTS.forEach(a => { CODE_MAP[a.code] = a; });

/**
 * 模糊匹配机场（按代码 / 中文名 / 英文名）
 * 返回前 8 个匹配项
 */
export function searchAirports(input) {
  if (!input) return [];
  const q = String(input).trim().toLowerCase();
  const matches = AIRPORTS.filter(a =>
    a.code.toLowerCase().includes(q) ||
    a.cn.toLowerCase().includes(q) ||
    a.en.toLowerCase().includes(q)
  );
  // 优先：完整 code 匹配 → code startsWith → 其他
  matches.sort((a, b) => {
    const aCode = a.code.toLowerCase();
    const bCode = b.code.toLowerCase();
    if (aCode === q && bCode !== q) return -1;
    if (bCode === q && aCode !== q) return 1;
    if (aCode.startsWith(q) && !bCode.startsWith(q)) return -1;
    if (bCode.startsWith(q) && !aCode.startsWith(q)) return 1;
    return 0;
  });
  return matches.slice(0, 8);
}

export function findAirportByCode(code) {
  if (!code) return null;
  return CODE_MAP[String(code).toUpperCase()] || null;
}

/** 中文显示：上海浦东国际机场 (PVG) */
export function formatAirportCn(airport) {
  if (!airport) return '';
  return `${airport.cn} (${airport.code})`;
}

/** 英文显示：Shanghai Pudong International Airport (PVG) */
export function formatAirportEn(airport) {
  if (!airport) return '';
  return `${airport.en} (${airport.code})`;
}

export default AIRPORTS;
